import { useState } from "react";
import { PageHeader } from "@/components/PageHeader";
import { SharedKanbanBoard } from "@/components/jobs/kanban/SharedKanbanBoard";
import { useKanbanMatches } from "@/hooks/matches/useKanbanMatches";
import { usePageTitle } from "@/hooks/usePageTitle";
import { CandidateHiredWorkforceModal } from "@/components/candidates/CandidateHiredWorkforceModal";
import { KanbanCandidate } from "@/components/jobs/kanban/types";

const Kanban = () => {
	usePageTitle("Recruitment Pipeline");
	const { loading, matches, handleStageChange, refreshMatches } = useKanbanMatches({ showAllMatches: true });
	const [hiredMatch, setHiredMatch] = useState<KanbanCandidate | null>(null);

	if (loading) {
		return (
			<div className="flex justify-center p-8">
				<div className="animate-spin h-8 w-8 border-2 border-digger-blue border-t-transparent rounded-full"></div>
			</div>
		);
	}

	return (
		<div className="h-full overflow-hidden flex flex-col">
			<PageHeader title="Recruitment Pipeline" />
			<div className="flex-1 overflow-auto p-4 w-full" data-tour="kanban-board">
				<SharedKanbanBoard
					showAllMatches={true}
					matches={matches}
					onStageChange={handleStageChange}
					onRefresh={refreshMatches}
					onMatchHired={(match) => setHiredMatch(match)}
				/>
			</div>

			{hiredMatch && (
				<CandidateHiredWorkforceModal
					isOpen={true}
					onClose={() => setHiredMatch(null)}
					candidateId={hiredMatch.candidateId}
					candidateName={hiredMatch.name}
				/>
			)}
		</div>
	);
};

export default Kanban;
